var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "volume-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M8 20.0004H5.33333C4.59695 20.0004 4 19.4035 4 18.6671V13.3338C4 12.5974 4.59695 12.0004 5.33333 12.0004H8L12.6667 6.00044C12.9075 5.53274 13.4533 5.31042 13.9523 5.47677C14.4514 5.64312 14.7547 6.14847 14.6667 6.66711V25.3338C14.7547 25.8524 14.4514 26.3578 13.9523 26.5241C13.4533 26.6905 12.9075 26.4682 12.6667 26.0004L8 20.0004"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M21.8638 12.8037C21.5709 12.5108 21.0961 12.5108 20.8032 12.8037C20.5103 13.0965 20.5103 13.5714 20.8032 13.8643L21.8638 12.8037ZM26.1365 19.1976C26.4294 19.4905 26.9043 19.4905 27.1972 19.1976C27.4901 18.9048 27.4901 18.4299 27.1972 18.137L26.1365 19.1976ZM27.1972 13.8643C27.4901 13.5714 27.4901 13.0965 27.1972 12.8037C26.9043 12.5108 26.4294 12.5108 26.1365 12.8037L27.1972 13.8643ZM20.8032 18.137C20.5103 18.4299 20.5103 18.9048 20.8032 19.1976C21.0961 19.4905 21.5709 19.4905 21.8638 19.1976L20.8032 18.137ZM20.8032 13.8643L26.1365 19.1976L27.1972 18.137L21.8638 12.8037L20.8032 13.8643ZM26.1365 12.8037L20.8032 18.137L21.8638 19.1976L27.1972 13.8643L26.1365 12.8037Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.dc3bd8303287d1cde99ff4a0bfed29fe.svg";
export { ForwardRef as ReactComponent };